import { Directive } from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';

@Directive({
  selector: '[appStrongPasswordValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: StrongPasswordValidatorDirective, multi: true }]
})
export class StrongPasswordValidatorDirective implements Validator{

  constructor() { }

  validate(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }
    if (control.value.length < 8) {
      return {error: 'too_short'};
    }
    if (!control.value.match('[A-Z]')) {
      return {error: 'no_upper_case'};
    }
    if (!control.value.match('[a-z]')) {
      return {error: 'no_lower_case'};
    }
    if (!control.value.match('[0-9]')) {
      return {error: 'no_number'};
    }
    if (!control.value.match('[^A-Za-z0-9]')) {
      return {error: 'no_special_character'};
    }
    return null;
  }
}
